export interface ITag {
    tag: string
    name: string
    category: string
    internal_name: string
}

export type MenuItem = {tag: string; children: MenuItem[] }

export class Tags {

    constructor(public readonly menus: MenuItem[], public readonly tags: { [key: string]: ITag }) {
        //
    }

    moduleTag(tags: string[]): string {
        let t = ''
        tags.forEach(tag => {
            if (this.tags[tag].category == '模式') {
                t = tag
                return
            }
        })
        return t
    }

}
